import React from 'react';
import ScrollAnimation from 'react-scroll-animation-wrapper';
import { getCurrentBrowserWidth } from 'swag-client-common/utils/ui.utils';
import css from './animate.scss';
const getCorrectOffset = offset => {
  if (offset === undefined) {
    return 100;
  }
  const currentScreenWidth = getCurrentBrowserWidth();
  if (currentScreenWidth >= 1920) {
    return offset;
  }
  if (currentScreenWidth < 1920 && currentScreenWidth >= 1024) {
    return offset * currentScreenWidth / 1920;
  }
  if (currentScreenWidth < 1024) {
    return 50;
  }
  return offset;
};
const AnimationWrapper = ({
  animateIn = css.animate__fadeInUp,
  animateOut = '',
  children,
  offset = 100,
  duration = 0.75,
  delay = 0,
  initiallyVisible = false,
  animateOnce = true,
  style,
  scrollableParentSelector,
  className,
  animatePreScroll = true
}) => /*#__PURE__*/React.createElement(ScrollAnimation, {
  animateIn: animateIn,
  animateOut: animateOut,
  offset: getCorrectOffset(offset),
  duration: duration,
  delay: delay,
  initiallyVisible: initiallyVisible,
  animateOnce: animateOnce,
  style: style,
  scrollableParentSelector: scrollableParentSelector,
  className: className,
  animatePreScroll: animatePreScroll,
  animateOnlyOnScrollDown: true
}, children);
export default AnimationWrapper;